<template>
 <!-- 隱私權頁面 -->
  <div
    class="p-3"
    style="margin: auto; text-align: left; white-space: pre-wrap"
  >
    {{ $t("privacy_policy", [hostname]) }}
  </div>
</template>
<script>
export default {
  data() {
    return {
      hostname: window.location.hostname,
    };
  },
};
</script>
